// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"91f2959bdb307dfb","894":"ec7228d217b32871"}[chunkId] + ".js";
};